import Bootstrap from 'bootstrap';
import Swiper from 'swiper';
import PNotify from 'pnotify/dist/es/PNotify.js';

require("@fancyapps/fancybox");

window.$ = $;
PNotify.defaults.delay = 1200;



window.debounce = function(func, wait, immediate) {
	var timeout;
	return function() {
		var context = this, args = arguments;
		var later = function() {
			timeout = null;
			if (!immediate) func.apply(context, args);
		};
		var callNow = immediate && !timeout;
		clearTimeout(timeout);
		timeout = setTimeout(later, wait);
		if (callNow) func.apply(context, args);
	};
};

window.cart = {

	add: function(form) {
		var data = $(form).serialize();
		
		$.ajax({
            type: 'POST',
            dataType: 'json',
            url: '',
            data: data,
            success: function(response) {
				if (response.success) {
					window.cart.setTotalQty(response.cart.totalQty);
					window.cart.reload('minicart');
					$.fancybox.close();
					PNotify.success({
						text: 'De artikelen zijn toegevoegd aan je winkelmand.',
						textTrusted: true,
						icon: null
					});
				} else {
					PNotify.error({
						text: response.error,
						textTrusted: true,
						icon: null
					});
				}
			}
		});
	},

	updateLine: function(form) {
		var data = $(form).serialize();

		$.ajax({
            type: 'POST',
            dataType: 'json',
            url: '',
            data: data,
            success: function(response) {
				window.cart.setTotalQty(response.cart.totalQty);
				window.cart.reload('minicart');
				window.cart.reload('totals');
			}
		});
	},

	deleteLine: function(lineId) {
		var data = {
            action: 'commerce/cart/update-cart',
            lineItems: {[lineId]: {'remove': true}}
        };
		data[window.csrfTokenName] = window.csrfTokenValue;

		$.ajax({
            type: 'POST',
            dataType: 'json',
            url: '',
            data: data,
            success: function(response) {
				if (response.success) {
					window.cart.setTotalQty(response.cart.totalQty);
					window.cart.reload('minicart');
					window.cart.reload('lines');
					window.cart.reload('totals');
				} else {
					alert(response.error);
				}
			}
		});
	},

	setTotalQty: function(qty) {
		$('[data-cart-totalqty]').removeClass('is-null').html(qty);
		if (qty == 0) {
			$('[data-cart-totalqty]').addClass('is-null');
		}
	},

	reload: function(part) {
		var $part = $('[data-checkout-part=\'' + part + '\']');
		if ($part.length > 0) {
			var href = $part.data('checkout-part-href');
			$.ajax(href).done(function(html) {
				$part.html(html);
			});
		}

		return null;
	},

	setEventListeners: function() {
		$(document).on('submit', 'form.add-to-cart-form', function(e) {
			e.preventDefault();
			window.cart.add(this);
		});

		$(document).on('click', '[data-cart-delete-line]', function(e) {
			var id = $(this).data('cart-delete-line');
			window.cart.deleteLine(id);
		});
		
		$(document).on('submit', 'form[data-cart-update-line]', function(e) {
			e.preventDefault();
			window.cart.updateLine(this);
		});
	
		$(document).on('change', 'form[data-cart-update-line] input[data-qty]', function() {
			var $form = $(this).closest('form');
			$form.submit();
		});		
	}
};

window.checkout = {
	save: function(callbackSuccess) {
		var data = $('form#checkout').serialize();
		
		$.ajax({
            type: 'POST',
            dataType: 'json',
            url: '',
            data: data,
            success: function(response) {
				if (response.success) {
					if (typeof callbackSuccess == "function") {
						callbackSuccess(response);
					}
				} else {
					alert(response.error);
				}
			}
		});
	},

	reload: function(part) {
		var $part = $('[data-checkout-part=\'' + part + '\']');
		if ($part.length > 0) {
			var href = $part.data('checkout-part-href');
			$.ajax(href).done(function(html) {
				$part.html(html);
			});
		}

		return null;
	},

	setEventListeners: function() {
		$(document).on('click', '#checkoutSubmit', function(e) {
			e.preventDefault();

			var $button = $(this);

			window.checkout.save(function() {
				var data = {
					action: $button.data('url-action'),
					redirect: $button.data('url-redirect'),
					cancelUrl: $button.data('url-cancel')
				};

				data[window.csrfTokenName] = window.csrfTokenValue;
		
				$.ajax({
					type: 'POST',
					dataType: 'json',
					url: '',
					data: data,
					success: function(response) {
						if (typeof(response['error']) !== "undefined") {
							PNotify.error({
								text: response['error'],
								icon: false
							});

							return;
						}
						
						if (typeof(response['success']) !== "undefined") {
							window.location.replace(response['redirect']);
						}
					}
				});
			});		
		});

		$(document).on('blur', '#zipCode', function() {
			window.checkout.save(function() {
				window.checkout.reload('shipping');
				window.checkout.reload('totals');
			});
		});

		$(document).on('change', 'input[name=\'shippingMethodHandle\']', function() {
			window.checkout.save(function() {
				window.checkout.reload('shipping-dates');
				window.checkout.reload('shipping-timeslots');
				window.checkout.reload('totals');
			});
		});

		$(document).on('change', 'select#deliveryDate', function() {
			window.checkout.save(function() {
				window.checkout.reload('shipping-timeslots');
			});
		})
	}
}

$(function() {

	window.cart.setEventListeners();
	window.checkout.setEventListeners();

	$(document).on('click', 'button[data-qty-step]', function() {
		var type = $(this).data('qty-step');
		var $input = $(this).parent().find('input');

		var currentValue = parseInt($input.val());
		var newValue = (type == 'min') ? (currentValue - 1) : (currentValue + 1);
		
		var minValue = $input.attr('min') != "" ? parseInt($input.attr('min')) : 0;
		var maxValue = $input.attr('max') != "" ? parseInt($input.attr('max')) : 999999;

		if (newValue >= minValue && newValue <= maxValue) {
			$input.val(newValue).change();
		}
	});

	$(document).on('change', 'input[data-qty]', function() {
		var $input = $(this);
		var newValue = $input.val();
		var minValue = $input.attr('min') != "" ? parseInt($input.attr('min')) : 0;
		var maxValue = $input.attr('max') != "" ? parseInt($input.attr('max')) : 999999;

		if (newValue < minValue) { $input.val(minValue); }
		if (newValue > maxValue) { $input.val(maxValue); }
	});

	$(document).on('change', '.category-categories select', function() {
		var url = $(this).val(); // get selected value
		if (url) { // require a URL
			window.location = url; // redirect
		}
		return false;
	});

    var mySwiper = new Swiper ('.swiper-container', {
		loop: true,
		spaceBetween: 30,
		autoplay: {
			delay: 4000,
		},
		speed: 3000,
		effect: 'fade',
		fadeEffect: {
			crossFade: true
		}
	});
});


(function($){
	$.unserialize = function(serializedString){
		var str = decodeURI(serializedString);
		var pairs = str.split('&');
		var obj = {}, p, idx, val;
		for (var i=0, n=pairs.length; i < n; i++) {
			p = pairs[i].split('=');
			idx = p[0];

			if (idx.indexOf("[]") == (idx.length - 2)) {
				// Eh um vetor
				var ind = idx.substring(0, idx.length-2)
				if (obj[ind] === undefined) {
					obj[ind] = [];
				}
				obj[ind].push(p[1]);
			}
			else {
				obj[idx] = p[1];
			}
		}
		return obj;
	};
})(jQuery);